import React from "react";
import { Facebook, Linkedin, Instagram, Twitter } from "lucide-react"; // using Lucide icons

export default function Footer() {
  return (
    <footer className="bg-black text-samCream py-10 text-center">
      {/* --- Social Icons Section --- */}
      <div className="flex justify-center space-x-6 mb-6">
        {/* Facebook */}
        <a
          href="https://www.facebook.com/people/Liqoura-Global/61583861498621/"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-samAmber transition-colors"
          aria-label="Facebook"
        >
          <Facebook className="w-6 h-6" />
        </a>

        {/* LinkedIn */}
        <a
          href="https://www.linkedin.com"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-samAmber transition-colors"
          aria-label="LinkedIn"
        >
          <Linkedin className="w-6 h-6" />
        </a>

        {/* X (Twitter) */}
        <a
          href="https://www.twitter.com"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-samAmber transition-colors"
          aria-label="X (Twitter)"
        >
          <Twitter className="w-6 h-6" />
        </a>

        {/* Instagram */}
        <a
          href="https://www.instagram.com/liqoura_global"
          target="_blank"
          rel="noopener noreferrer"
          className="hover:text-samAmber transition-colors"
          aria-label="Instagram"
        >
          <Instagram className="w-6 h-6" />
        </a>
      </div>

      {/* --- Copyright --- */}
      <p className="text-sm">
        © {new Date().getFullYear()} Liquora Global. All Rights Reserved.
      </p>
    </footer>
  );
}
